import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Box,
    Slide,
    DialogActions,
    Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import "./style.scss";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import api from "../../../../constants/api";
import LoadingIndicator from "../../../../utils/loading";
import notifier from "../../../../utils/notifier";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SelectTimeModal = ({ setSelectedTime, selectedTime, id }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [localTime, setLocalTime] = useState(dayjs()); 

    const handleOpenPopup = () => {
        setLocalTime(selectedTime || dayjs('00:00:00', 'HH:mm:ss'));
        setOpen(true);
    };

    const onClose = () => setOpen(false);

    const handleSave = () => {
        const time = dayjs(localTime).format('HH:mm:ss');
        setLoading(true);
        api.diagnostics.dailyRunsTime(id, { time })
            .then((response) => {
                setLoading(false);
                setOpen(false);
                setSelectedTime(localTime); 
                notifier.success(response?.message);
            })
            .catch((error) => {
                setLoading(false);
                console.error("Failed to update time:", error);
                notifier.error(error?.message);
            });
    };

    return (
        <>
            <EditIcon
                sx={{ color: 'black', mr: 2, cursor: 'pointer', fontSize: '18px', margin: '0px 5px' }}
                onClick={handleOpenPopup}
            />
            <Dialog
                open={open}
                keepMounted
                onClose={onClose}
                TransitionComponent={Transition}
                className="alertPopup"
            >
                <DialogTitle>
                    Set daily runs at
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <LoadingIndicator isloading={loading} />
                <DialogContent dividers className="time-modal-content">
                    <LocalizationProvider dateAdapter={AdapterDayjs} className='p-0'>
                        <DemoContainer components={['TimePicker']} className='p-0'>
                            <TimePicker
                                value={localTime}
                                className="w-100 p-0"
                                onChange={(newValue) => setLocalTime(newValue)}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </DialogContent>
                <DialogActions className="justify-content-center">
                    <Box textAlign="left" mt={2} className="continue-btn">
                        <Button variant="contained" onClick={handleSave}>
                            Save
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    );
};


export default SelectTimeModal;
